import { useEffect } from 'react'
import { THEME_ENUM } from '@/constants/theme.constant'
import { setMode, useAppSelector, useAppDispatch } from '@/store'
import type { Mode } from '@/types/theme'

function useDarkMode(): [
    isEnabled: boolean,
    onModeChange: (mode: Mode) => void
] {    
    const { MODE_DARK, MODE_LIGHT } = THEME_ENUM
    
    // Get mode from Redux store instead of separate localStorage
    const mode = useAppSelector((state) => state.theme.mode)
    const isEnabled = mode === MODE_DARK

    const dispatch = useAppDispatch()
    const onModeChange = (mode: Mode) => {
        dispatch(setMode(mode))
    }

    useEffect(() => {
        if (window === undefined) {
            return
        }
        const root = window.document.documentElement
        root.classList.remove(MODE_LIGHT, MODE_DARK)
        root.classList.add(mode)

        const isDark = mode === MODE_DARK
        const themeColorMeta = document.querySelector(
            'meta[name="theme-color"]'
        )
        if (themeColorMeta) {
            themeColorMeta.setAttribute(
                'content',
                isDark ? '#111827' : '#ffffff'
            )
        }
    }, [mode, MODE_DARK, MODE_LIGHT])

    return [isEnabled, onModeChange]
}

export default useDarkMode
